module.exports = __webpack_public_path__ + "img/pic3.ec7a482b.png";